import { useEffect } from "react";
import { API_CASINO } from "../../api/casino";
import { useAppSelector } from "../../store/index.ts";
import { useDispatch } from "react-redux";
import {
  setCategoryList,
  setCategoryLoading,
  setCategoryWager,
  setFillCategoryById,
  setSportBookGame
} from "../../store/gamesSlice.js";
import { setCollectionId } from "../../store/commonSlice.js";
import { useLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME, MINUTES_CASH } from "../../store/enums.js";
import { getSecondByMinutes } from "../../utils/utils.js";

const defaultSaveCat = {
  categoryList: [],
  currency: "",
  collectionId: 0,
  time: undefined,
  sportBookGame: null
};

export default function useCollection() {
  const dispatch = useDispatch();
  const currency = useAppSelector((state) => state.user.currency);
  const collectionHash = useAppSelector((state) => state.common.collectionList);
  const lang = useAppSelector((state) => state.common.lang);

  const [saveCategory, setSaveCategory] = useLocalStorage(ENUM_LCS_NAME.categories, defaultSaveCat);

  const collectionListSt = Object.keys(collectionHash).join(",");

  const fillCategoryById = (categories) => {
    let categoryWager = {};
    const categoryById = categories.reduce((prev, cur) => {
      prev[cur.id] = cur;
      if (cur.bonusWager) categoryWager = cur;

      return prev;
    }, {});

    dispatch(setCategoryWager(categoryWager));
    dispatch(setFillCategoryById(categoryById));
  };

  useEffect(() => {
    const collectionIds = Object.keys(collectionHash);

    if (!currency) return;
    if (!collectionIds.length) {
      dispatch(setCategoryLoading(false));
      return;
    }

    let isAnyCurrencyId = null;
    let currentCollectionId = null;
    dispatch(setCategoryLoading(true));

    collectionIds.forEach((collectionId) => {
      const collection = collectionHash[collectionId];
      if (collection.currencyList.length == 0) {
        isAnyCurrencyId = collectionId;
      }
      if (collection.currencyList.includes(currency)) {
        currentCollectionId = collectionId;
      }
    });

    if (!currentCollectionId) currentCollectionId = isAnyCurrencyId;
    if (!currentCollectionId) {
      dispatch(setCategoryLoading(false));
      dispatch(setCategoryList([]));
      return;
    }

    dispatch(setCollectionId(+currentCollectionId));
    const equalCollectId = saveCategory.collectionId == currentCollectionId;
    const equalCurrency = saveCategory.currency == currency;

    if (equalCurrency && equalCollectId) {
      if (+saveCategory?.time + getSecondByMinutes(MINUTES_CASH) > +new Date()) {
        if (saveCategory.collectionId) {
          const categoryList = saveCategory.categoryList;

          dispatch(setCollectionId(saveCategory.collectionId));
          dispatch(setCategoryList(categoryList));
          dispatch(setCategoryLoading(false));
          fillCategoryById(categoryList);
          dispatch(setSportBookGame(saveCategory.sportBookGame));
          // return;
        }
      }
    } else {
      setSaveCategory(defaultSaveCat);
    }

    API_CASINO.list
      .collection({ collectionId: +currentCollectionId, currency })
      .then((e) => {
        const data = e.data;
        const categoryList = data.categoryList;
        dispatch(setCategoryList(categoryList));
        if (categoryList.length) {
          setSaveCategory({
            categoryList,
            time: +new Date(),
            currency,
            collectionId: +currentCollectionId,
            sportBookGame: data.sportBookGame
          });
        }
        fillCategoryById(categoryList);
        dispatch(setSportBookGame(data.sportBookGame));
      })
      .catch(console.error)
      .finally(() => dispatch(setCategoryLoading(false)));
  }, [currency, collectionListSt, lang]);
}
